<script setup>
const props = defineProps({
  value: Boolean,
  disabled: {
    type: Boolean,
    default: false,
  },
  attributes: Object,
})
const emit = defineEmits(['input'])

function inputChange() {
  emit('input', !props.value)
}

function checkedStyle() {
  if (props.value) {
    return {
      backgroundColor: props.attributes?.primary_color || '#0099d0',
      borderColor: props.attributes?.primary_color || '#0099d0',
    }
  }
  return {}
}
</script>

<template>
  <label class="checkbox-wrapper">
    <input type="checkbox" :checked="value" :disabled="disabled" @change="inputChange" />
    <span class="checkmark" :style="checkedStyle()">
      <svg v-if="value" class="check-icon" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5L4.5 8.5L11 1.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
  </label>
</template>

<style scoped>
.checkbox-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-wrapper input {
  appearance: none;
  -webkit-appearance: none;
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  pointer-events: none;
}

.checkmark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  background-color: white;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkmark:hover {
  border-color: #9ca3af;
}

.check-icon {
  width: 12px;
  height: 12px;
}

input:focus + .checkmark {
  box-shadow: 0 0 0 2px rgba(0, 153, 208, 0.25);
}

input:disabled + .checkmark {
  opacity: 0.5;
}
</style>
